import React, { Fragment } from "react";
import { Route, Routes as Router, useLocation } from "react-router";

import {
  CLUBS,
  DASHBOARD,
  LOGIN,
  PLATFORM,
  PLATFORM_CLUBS,
  PLATFORM_PROPOSALS,
  PLATFORM_STAKING,
  PLATFORM_USERS,
  PLATFORM_VAULTS,
  PLATFORM_WITHDRAWAL,
  REGISTER,
  USERS,
} from "./common/constants/routes.constants";
import Platform from "./pages/Platform/Platform";
import Clubs from "./pages/Clubs/Clubs";
import Users from "./pages/Users/Users";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { useAuthContext } from "./context/AuthContext";
import Login from "./pages/Auth/Login";
import ClubDetails from "./pages/ClubDetails/ClubDetails";
import UserDetails from "./pages/UserDetails/UserDetails";
import PlatformClubs from "./pages/Platform/PlatformClubs";
import PlatformUsers from "./pages/Platform/PlatformUsers";
import PlatformVaults from "./pages/Platform/PlatformVaults";
import PlatformProposals from "./pages/Platform/PlatformProposals";
import PlatformStaking from "./pages/Platform/PlatformStaking";
import PlatformWithdrawal from "./pages/Platform/PlatformWithdrawal";

const Routes: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuthContext();

  if (
    isAuthenticated &&
    (location.pathname === LOGIN || location.pathname === REGISTER)
  ) {
    return <PlatformClubs />;
  }
  if (!isAuthenticated && location.pathname !== REGISTER) {
    return <Login />;
  }

  return (
    <Fragment>
      <Router>
        <Route element={<Login />} path={LOGIN} />
        <Route
          element={
            <ProtectedRoute>
              <PlatformClubs />
            </ProtectedRoute>
          }
          path={DASHBOARD}
        />
        <Route
          element={
            <ProtectedRoute>
              <Platform />
            </ProtectedRoute>
          }
          path={PLATFORM}
        />
        <Route
          element={
            <ProtectedRoute>
              <PlatformClubs />
            </ProtectedRoute>
          }
          path={PLATFORM_CLUBS}
        />
        <Route
          element={
            <ProtectedRoute>
              <ClubDetails />
            </ProtectedRoute>
          }
          path={`${PLATFORM_CLUBS}/:clubAddress`}
        />
        <Route
          element={
            <ProtectedRoute>
              <PlatformUsers />
            </ProtectedRoute>
          }
          path={PLATFORM_USERS}
        />
        <Route
          element={
            <ProtectedRoute>
              <PlatformVaults />
            </ProtectedRoute>
          }
          path={PLATFORM_VAULTS}
        />
        <Route
          element={
            <ProtectedRoute>
              <PlatformProposals />
            </ProtectedRoute>
          }
          path={PLATFORM_PROPOSALS}
        />
        <Route
          element={
            <ProtectedRoute>
              <PlatformStaking />
            </ProtectedRoute>
          }
          path={PLATFORM_STAKING}
        />
        <Route
          element={
            <ProtectedRoute>
              <PlatformWithdrawal />
            </ProtectedRoute>
          }
          path={PLATFORM_WITHDRAWAL}
        />
        <Route
          element={
            <ProtectedRoute>
              <Clubs />
            </ProtectedRoute>
          }
          path={CLUBS}
        />
        <Route
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
          path={USERS}
        />
        <Route
          element={
            <ProtectedRoute>
              <UserDetails />
            </ProtectedRoute>
          }
          path={`${USERS}/:userAddress`}
        />
      </Router>
    </Fragment>
  );
};

export default Routes;
